import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Iconify from 'src/components/iconify';
import { dateFormatter } from '../../risk-register/feching';
// ----------------------------------------------------------------------
export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow, currentItem, serialNumber, chartsAccountList }) {
    const { date_of_receipt, account_chart, credit_card_expiry_date,
        bank_information, date_of_cheque, debit_card_expiry_date
        , cheque_account_number, credit, debit, amount_received, payment_method,
         note, remaining_balance, days_left } = row;
    return (
        <>
            <TableRow hover selected={selected} >
                <TableCell padding="checkbox">
                    <Iconify icon="solar:pen-bold" onClick={() => {
                        onEditRow(row);
                    }} />
                </TableCell>
                <TableCell>{serialNumber}</TableCell>
                <TableCell>{account_chart?.name}</TableCell>
                <TableCell>{account_chart?.account_type?.name}</TableCell>
                <TableCell>{amount_received}</TableCell>
                <TableCell>{bank_information?.bank_name}</TableCell>
                <TableCell>{cheque_account_number}</TableCell>
                <TableCell>{credit}</TableCell>
                <TableCell>{debit}</TableCell>
                <TableCell>{dateFormatter(credit_card_expiry_date) || dateFormatter(debit_card_expiry_date) || dateFormatter(date_of_cheque)}</TableCell>
                <TableCell>{dateFormatter(date_of_receipt)}</TableCell>
                <TableCell>{days_left}</TableCell>
                <TableCell>{note}</TableCell>
                <TableCell>{payment_method}</TableCell>
                <TableCell>{remaining_balance}</TableCell>
            </TableRow >

        </>
    );
}
UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};